import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Form, Col, Button, Modal, Row} from "react-bootstrap";
import axios from 'axios';
import { validate, format } from '@validatecl/rut';
import PorcentajeBenef from './porcentajebenef'
import ParentescoBenef from './parentescoBenef'
// import Region from './region'
// import Ciudad from './ciudad'
import Comuna from './comuna'


let baseUrl = 'https://b316wmuwh1.execute-api.us-east-1.amazonaws.com/default/res_json_Beneficiario'
axios.defaults.headers.post['authorizationToken'] = '&S396b<eg5Zn(HiLe)BBNtc&';


class ModalBeneficiario extends React.Component{

    constructor(props){
        super(props)
        this.state = {
            id_gestion: this.props.id_gestion,
            id_contacto: this.props.id_contacto,
            id_campana: this.props.id_campana,
            id_contacto_genesys: this.props.id_contacto_genesys,
            fono: this.props.fono,
            cola: this.props.cola,
            id_ejecutivo: this.props.id_ejecutivo,
            formValid: true,
            Region: '',
            RegionId: '',
            Comuna: '',
            ComunaId: '',
            Ciudad: '',
            CiudadId: '',
            Rut:'',
            enviado : 0
        };
        
        this.handleEnviodatos = this.handleEnviodatos.bind(this)
        this.handleInputChange = this.handleInputChange.bind(this)
        this.validaRut = this.validaRut.bind(this)
        this.resetearSelect = this.resetearSelect.bind(this)
        // this.handleChangeRegion = this.handleChangeRegion.bind(this)
        // this.handleChangeCiudad = this.handleChangeCiudad.bind(this)
        this.handleChangeComuna = this.handleChangeComuna.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.handleClose = this.handleClose.bind(this)
        this.handleConfirm = this.handleConfirm.bind(this)
        this.handleMostrarModal = this.handleMostrarModal.bind(this)
        this.handleInputChangeNacionalidad = this.handleInputChangeNacionalidad.bind(this)
        this.handleInputChangeProfesion = this.handleInputChangeProfesion.bind(this)
        this.handleInputChangeParentesco = this.handleInputChangeParentesco.bind(this)
        this.resetall = this.resetall.bind(this)

        
    }

    resetall(){
        this.setState({
            Rut: '',
            Nombre: '',
            SegundoNombre: '',
            ApPaterno: '',
            ApMaterno: '',
            Region: '',
            RegionDesc: '',
            RegionId: '',
            Ciudad: '',
            CiudadDesc: '',
            CiudadId: '',
            Comuna: '',
            ComunaDesc: '',
            ComunaId: '',
            TipoCalle: '',
            Direccion: '',
            TipoVivienda: '',
            Numeracion: '',
            Fechanacimiento: '',
            Telefono: '',
            ParentescoId: '',
            ParentescoDesc: '',
            Porcentaje: '',
            Mail: '',
        })
    }

    //metodo para la accion de la presion del btn submit 
    async handleSubmit(e){
        e.preventDefault();
        if(this.dataValidation === false){
            this.setState({ formValid: false})
            return (alert('Ingresa campos requeridos!'))
        }else{
            console.log('obtengo metodo de los datos')
            this.handleMostrarModal()
        }   
    }

    //abre el modal para confirmar el envio de datos
    async handleMostrarModal(){
        console.log('confirma los datos')
        this.setState({show:true})
    }

    //confirma el envio de datos para continuar con el envio de datos
    async handleConfirm() {
        this.setState({show:false, confirm:true})
        this.handleEnviodatos()//metodo de envio de datos
        
    }

    //cierra el modal para confirmar los datos
    async handleClose(){
        this.setState({
            show: false,
        })
    }

    //valida que los datos que esten en el formulario sean correctos en este caso que no se encuentren vacios
    async dataValidation(){
        console.log('Validando Datos')
        if(this.state.dataCiu !== '' && this.state.data !== ''){
            return true
        }else{
            
            return false
        }
    }

    //con este metodo se guarda el dato de ingresado con la variable ingresada en los props
    async handleInputChange(event){
        const target = event.target;
        const valor = target.value;
        const nombre = target.name;
        this.setState({
            [nombre]: valor
        })
    }

    //metodo para validar el rut
    validaRut(rut) {
        console.log('validando rut...')
        const isValid = validate(rut);

        console.log(isValid)
        if(isValid === false){
            alert('rut no valido, por favor escribir nuevamente');
            return false
        }else{
            return true
        }
        
    }

    //seleccion para region ciuda y comuna ademas del resetearSelect() cuando se cambia algun componente anterior
    resetearSelect(){
        this.setState({
            Region: '',
            RegionId: '',
            ComunaId: '',
            Comuna: '',
            Ciudad: '',
            CiudadId:'',
        })
    }

    // handleChangeRegion(event) {
    //     if(event.target.value === ''){
    //         this.resetearSelect()
    //     }else{
    //         console.log(event.target.value)
    //         this.setState({
    //             Region: event.target.value,
    //             RegionId: event.target.value.split('-')[0],
    //             RegionDesc: event.target.value.split('-')[1],
    //             Ciudad:'',
    //             Comuna:'',
    //         });
    //     }
    // }

    // handleChangeCiudad(event) {
    //     if(event.target.value === ''){
    //         this.resetearSelect()
    //     }else{
    //         console.log(event.target.value)
    //         this.setState({
    //             Ciudad: event.target.value,
    //             CiudadId: event.target.value.split('-')[0],
    //             CiudadDesc: event.target.value.split('-')[1],
    //             Comuna: ''
    //         });
    //     }
    // }

    handleChangeComuna(event) {
        if(event.target.value === ''){
            this.resetearSelect()
        }else{
            console.log(event.target.value)
            this.setState({
                Comuna: event.target.value,
                ComunaId: event.target.value.split('-')[0],
                ComunaDesc: event.target.value.split('-')[1],
            });
        }
    }
    //fin region,ciudad,comuna

    
    handleInputChangeNacionalidad=(event)=>{
        if(event.target.value !== ''){
            this.setState({
                Nacionalidad: event.target.value,
                NacionalidadId: event.target.value.split('|')[1],
                NacionalidadDesc: event.target.value.split('|')[2],
            })
        }
    }

    handleInputChangeProfesion=(event)=>{
        if(event.target.value !== ''){
            // console.log(event.target.value)
            this.setState({
                Profesion: event.target.value,
                ProfesionId: event.target.value.split('|')[0],
                ProfesionDesc: event.target.value.split('|')[1],
            })
        }
    }

    handleInputChangeParentesco=(event)=>{
        if(event.target.value !== ''){
            // console.log(event.target.value)
            this.setState({
                Parentesco: event.target.value,
                ParentescoId: event.target.value.split('-')[1],
                ParentescoDesc: event.target.value.split('-')[2],
            })
        }
    }

    async handleEnviodatos() {
        const body = JSON.stringify({
            id_gestion: this.state.id_gestion,
            id_contacto: this.state.id_contacto,
            id_campana: this.state.id_campana,
            id_contacto_genesys: this.state.id_contacto_genesys,
            fono: this.state.fono,
            cola: this.state.cola,
            id_ejecutivo: this.state.id_ejecutivo,
            Rut: format(this.state.Rut, false),
            Nombre: this.state.Nombre,
            SegundoNombre: this.state.SegundoNombre,
            ApPaterno: this.state.ApPaterno,
            ApMaterno: this.state.ApMaterno,
            Region: this.state.Region,
            RegionDesc: this.state.RegionDesc,
            RegionId: this.state.RegionId,
            Ciudad: this.state.Ciudad,
            CiudadDesc: this.state.CiudadDesc,
            CiudadId: this.state.CiudadId,
            Comuna: this.state.Comuna,
            ComunaDesc: this.state.ComunaDesc,
            ComunaId: this.state.ComunaId,
            TipoCalle: this.state.TipoCalle,
            Direccion: this.state.Direccion,
            TipoVivienda: this.state.TipoVivienda,
            Numeracion: this.state.Numeracion,
            Fechanacimiento: this.state.Fechanacimiento,
            Telefono: this.state.Telefono,
            ParentescoId: this.state.ParentescoId,
            ParentescoDesc: this.state.ParentescoDesc,
            Porcentaje: this.state.Porcentaje,
            Mail: this.state.Mail,
        })
        console.log(body)
        if(this.state.Rut === ''){
            await axios.post(baseUrl,body)
            .then(response => {
                console.log('exito al enviar POST Datos Titular: ');
                if (response.status === 200) {
                    this.state.enviado++;
                    console.log(this.state.enviado);   
                }
                document.getElementsByClassName('btn-close')[0].click()
            })
            .catch(response => {
                console.log(response + ' error POST envio datos')
            })
        }else{
            if(this.validaRut(this.state.Rut) === true){
                await axios.post(baseUrl,body)
                .then(response => {
                    console.log('exito al enviar POST Datos Titular: ');
                    if (response.status === 200) {
                        this.state.enviado++;
                        console.log(this.state.enviado);   
                    }
                    this.resetall()
                })
                .catch(response => {
                    console.log(response + ' error POST envio datos')
                })
            }
        }
        if(this.state.enviado >= 5){
            document.getElementsByClassName('btn-close')[0].click()
        }
    }

    render(){
        var currentTime = new Date()
        var month1 = currentTime.getMonth() + 1
        var day1 = currentTime.getDate()
        var year1 = currentTime.getFullYear()
        if (month1<10) month1="0"+month1;
        if (day1<10) day1="0"+day1;
        const curdate = year1 + "-" + month1 + "-" + day1
        return(
            <Container>
                <Modal.Header closeButton>
                    <Modal.Title id="example-custom-modal-styling-title">
                        Datos Beneficiario
                    </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form onSubmit={this.handleSubmit}>
                            <Row className="mb-3">
                                <Form.Group as={Col} md="3" className="mb-3">
                                    <Form.Label>Nombre</Form.Label>
                                    <Form.Control name='Nombre' size='sm' value={this.state.Nombre} onChange={this.handleInputChange} required/>
                                </Form.Group>
                                <Form.Group as={Col} md="3" className="mb-3">
                                    <Form.Label>Segundo Nombre</Form.Label>
                                    <Form.Control name='SegundoNombre' size='sm' value={this.state.SegundoNombre} onChange={this.handleInputChange} required/>
                                </Form.Group>
                                <Form.Group as={Col} md="3" className="mb-3">
                                    <Form.Label>Apellido Paterno</Form.Label>
                                    <Form.Control name='ApPaterno' size='sm' value={this.state.ApPaterno} onChange={this.handleInputChange} required/>
                                </Form.Group>
                                <Form.Group as={Col} md="3" className="mb-3">
                                    <Form.Label>Apellido Materno</Form.Label>
                                    <Form.Control name='ApMaterno' size='sm' value={this.state.ApMaterno} onChange={this.handleInputChange} required/>
                                </Form.Group>
                            </Row>
                            <Row className="mb-3">
                                <Form.Group as={Col} md="3" className="mb-3">
                                    <Form.Label>Fecha de nacimiento</Form.Label>
                                    <Form.Control size='sm' type='date' max={curdate} min="1900-01-01" name='Fechanacimiento' value={this.state.Fechanacimiento} onChange={this.handleInputChange} required/>
                                </Form.Group>
                                <Form.Group as={Col} md="3" className="mb-3">
                                    <Form.Label>Rut Beneficiario</Form.Label>
                                    <Form.Control name='Rut' size='sm' value={this.state.Rut} onChange={this.handleInputChange} required/>
                                </Form.Group>
                                <Form.Group as={Col} md="3" className="mb-3">
                                    <Form.Label>Telefono</Form.Label>
                                    <Form.Control name='Telefono' size='sm' value={this.state.Telefono} onChange={this.handleInputChange} required/>
                                </Form.Group>
                                <Form.Group as={Col} md="3" className="mb-3">
                                    <Form.Label>Parentesco</Form.Label>
                                    <Form.Control name='Parentesco' size='sm' as='select' value={this.state.Parentesco} onChange={this.handleInputChangeParentesco} required>
                                        <option value="">Seleccionar Parentesco</option>
                                        <ParentescoBenef></ParentescoBenef>
                                    </Form.Control>
                                </Form.Group>
                            </Row>
                            <Row className="mb-3">
                                {/* <Form.Group as={Col} md="4" className="mb-4">
                                    <Form.Label>Region</Form.Label>
                                    <Form.Control name='Region' size='sm' as="select" value={this.state.Region} onChange={this.handleChangeRegion} required>
                                        <option value="">Seleccionar Region</option>
                                        <Region></Region>
                                    </Form.Control>
                                </Form.Group>
                                <Form.Group as={Col} md="4" className="mb-4">
                                    <Form.Label>Ciudad</Form.Label>
                                    <Form.Control name='Ciudad' size='sm' as="select" value={this.state.Ciudad} onChange={this.handleChangeCiudad} required>
                                        <option value="">Seleccionar Ciudad</option>
                                        <Ciudad data={'1'}></Ciudad>
                                    </Form.Control>
                                </Form.Group> */}
                                <Form.Group as={Col} md="4" className="mb-4">
                                    <Form.Label>Comuna</Form.Label>
                                    <Form.Control name='Comuna' size='sm' as="select" value={this.state.Comuna} onChange={this.handleChangeComuna} required>
                                        <option value="">Seleccionar Comuna</option>
                                        <Comuna></Comuna>
                                    </Form.Control>
                                </Form.Group>
                                <Form.Group as={Col} md="4" className="mb-4">
                                    <Form.Label>Tipo Calle</Form.Label>
                                    <Form.Control name='TipoCalle' size='sm' as="select" value={this.state.TipoCalle} onChange={this.handleInputChange} required>
                                        <option value=''>Tipo Calle</option>
                                        <option value='Avenida'>Avenida</option>
                                        <option value='Pasaje'>Pasaje</option>
                                        <option value='Calle'>Calle</option>
                                    </Form.Control>
                                </Form.Group>
                            </Row>
                            <Row className="mb-3">
                                <Form.Group as={Col} md="4" className="mb-4">
                                    <Form.Label>Direccion</Form.Label>
                                    <Form.Control name='Direccion' size='sm' value={this.state.Direccion} onChange={this.handleInputChange} required/>
                                </Form.Group>
                                <Form.Group as={Col} md="4" className="mb-4">
                                    <Form.Label>Tipo de vivienda</Form.Label>
                                    <Form.Control name='TipoVivienda' placeholder="depto,casa,villa,parcela,etc" size='sm' value={this.state.TipoVivienda} onChange={this.handleInputChange} required/>
                                </Form.Group>
                                <Form.Group as={Col} md="4" className="mb-4">
                                    <Form.Label>Numeracion</Form.Label>
                                    <Form.Control name='Numeracion' size='sm' type='number' value={this.state.Numeracion} onChange={this.handleInputChange} required/>
                                </Form.Group>
                            </Row>
                            <Row>
                                <Form.Group as={Col} md="4" className="mb-4">
                                    <Form.Label>Porcentaje</Form.Label>
                                    <Form.Control name='Porcentaje' size='sm' as='select' value={this.state.Porcentaje} onChange={this.handleInputChange} required>
                                        <option value="">Seleccionar Porcentaje</option>
                                        <PorcentajeBenef id_gestion={this.state.id_gestion}></PorcentajeBenef>
                                    </Form.Control>
                                </Form.Group>
                            </Row>
                            <Button variant="primary" type="submit" id='btn_form'>Finalizar</Button>
                        </Form>
                        <Modal
                            show={this.state.show}
                            onHide={this.handleClose}
                            backdrop="static"
                            keyboard={false}
                        >
                        <Modal.Header closeButton>
                            {/* <Modal.Title>Modal title</Modal.Title> */}
                            </Modal.Header>
                            <Modal.Body>
                            Desea guardar los cambios del formulario?
                            </Modal.Body>
                            <Modal.Footer>
                            <Button variant="danger" onClick={this.handleClose}>
                                Cancelar
                            </Button>
                            <Button variant="primary" onClick={this.handleConfirm}>Confirmar</Button>
                            </Modal.Footer>
                        </Modal>
                    </Modal.Body>
            </Container>
        )
    }
}
export default ModalBeneficiario;